import React from 'react'
import styled from 'styled-components'
import scale from '../constants/scale'
import color from '../constants/colors'

const QuoteContainer = props => {

    return (
        <Wrapper>
            <QuoteImg src="/assets/quote.svg" />
            <Space height={'16px'} />
            <AddMargin>
                <Text 
                fontSize={'24px'} 
                fontWeight={'normal'} 
                letterSpacing={'-0.58px'} 
                color={color.BLACK}
                >{props.quote}</Text>
            </AddMargin>
            <Space height={'8px'} />
            <Text 
            fontSize={'17px'} 
            fontWeight={'bold'} 
            letterSpacing={'normal'} 
            color={color.BLACK}
            >{props.author}</Text>
        </Wrapper>
    )
}

export default QuoteContainer

const QuoteImg = styled.img`
    
`
const AddMargin = styled.div`
    margin-left: 5px
`
const Wrapper = styled.div`
    max-width: 350px;
    margin: 16px;
`
const Space = styled.div`
    height: ${props => props.height};
    ${scale.MOBILE} {
        height: ${props => props.mobileHeight};
    }
`
const Text = styled.p`
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    letter-spacing: ${props => props.letterSpacing};
    color: ${props => props.color};
    margin: 0px;
`